<template>
  <router-view/>
</template>
<style>
body {
  margin: 0px;
}
</style>
